import React from "react";

import ReportsListView from "./ReportsListView";
import useReportsList from "./hooks/useReportsList";

import "./Reports.scss";

const CompanyPortalReports = () => {
  const listProps = useReportsList();
  return <ReportsListView {...listProps} />;
};

export default CompanyPortalReports;
